import { render, staticRenderFns } from "./preview-providerinvoice.vue?vue&type=template&id=4cd4dcb4&scoped=true&"
import script from "./preview-providerinvoice.vue?vue&type=script&lang=js&"
export * from "./preview-providerinvoice.vue?vue&type=script&lang=js&"
import style0 from "./preview-providerinvoice.vue?vue&type=style&index=0&id=4cd4dcb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4dcb4",
  null
  
)

export default component.exports